/* src/app/shared/components/mce-editor/image-resize.component.scss */
.mce-image-outer {
  position: relative;
  display: inline-block;
  line-height: 0;
}
.mce-image-outer.mce-image-selected .mce-image-wrapper img {
  outline: 2px solid #4a90d9;
}
.mce-image-outer.mce-layout-inline {
  display: inline-block;
  float: none;
  margin: 0;
}
.mce-image-outer.mce-layout-centered {
  display: block;
  float: none;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}
.mce-image-outer.mce-layout-float-left {
  display: block;
  float: left;
  margin-right: 1rem;
  margin-bottom: 0.5rem;
}
.mce-image-outer.mce-layout-float-right {
  display: block;
  float: right;
  margin-left: 1rem;
  margin-bottom: 0.5rem;
}
.mce-image-wrapper {
  position: relative;
  display: block;
  line-height: 0;
}
.mce-image-wrapper img {
  display: block;
  max-width: 100%;
}
.mce-image-toolbar {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 2px;
  padding: 4px 6px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: nowrap;
  z-index: 100;
  line-height: normal;
}
.mce-image-toolbar button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: #444;
}
.mce-image-toolbar button mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
}
.mce-image-toolbar button:hover {
  background: #eeeeee;
}
.mce-image-toolbar button.active {
  background: #e3edf7;
  color: #1565c0;
}
.mce-drag-button {
  cursor: grab;
}
.mce-drag-button:active {
  cursor: grabbing;
}
.mce-toolbar-separator {
  width: 1px;
  height: 18px;
  background: #e0e0e0;
  margin: 0 2px;
  flex-shrink: 0;
  align-self: center;
}
.mce-caption-wrapper {
  display: block;
  line-height: normal;
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
  border-radius: 0 0 3px 3px;
}
.mce-caption-input {
  display: block;
  width: 100%;
  padding: 6px 10px;
  border: none;
  background: transparent;
  font-size: 13px;
  color: #555;
  text-align: center;
  outline: none;
  box-sizing: border-box;
}
.mce-caption-input::placeholder {
  color: #aaa;
  font-style: italic;
}
.mce-caption-input:focus {
  background: #fff;
}
.mce-resize-handle {
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 12px;
  height: 12px;
  background: #4a90d9;
  border: 2px solid #fff;
  border-radius: 2px;
  cursor: nwse-resize;
  z-index: 10;
}
/*# sourceMappingURL=image-resize.component-IBM7LJYD.css.map */
